/*
 * @Descripttion: 
 * @version: 
 * @Author: zm
 * @Date: 2023-08-30 16:22:30
 * @LastEditors: zm
 * @LastEditTime: 2023-08-30 16:46:32
 */
import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon/Index.vue'// svg 组件

// 全局注册svg组件
Vue.component('svg-icon', SvgIcon)
// 工程化导入svg图片
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)